import React from "react";
import { Modal } from "@components/modal";
import { FooterButtons } from "@components/modal/footerButtons";
import { ModalButton, OutlineModalButton } from "@components/modal/modalButton";
import Wrapper from "./bankStatementSkipWarning.styles";

export default function BankStatementSkipWarning({ visible, close, accept }) {
  return (
    <Modal
      visible={visible}
      header="Submitting later will delay an outcome"
      size="small"
      closeable={false}
      footer={
        <FooterButtons>
          <OutlineModalButton onClick={close}>
            GO BACK
          </OutlineModalButton>
          <ModalButton onClick={accept}>
            OK
          </ModalButton>
        </FooterButtons>
      }
      onClose={close}
    >
      <Wrapper>
        <div className="modalContent">
          <p>Thank you. We will send you an application resumption link shortly. The sooner you provide your statements using this link, the faster we are able to finalise your application.</p>
          <p>Please note that this is the only way you can provide your bank statements.</p>
        </div>
      </Wrapper>
    </Modal>
  );
}
